import { render, staticRenderFns } from "./amountSalesReport.vue?vue&type=template&id=4fc706b4"
import script from "./amountSalesReport.vue?vue&type=script&lang=js"
export * from "./amountSalesReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports